<script>
import TaskView from '../components/task/view/TaskView.vue';

export default {
  name: 'TasksPage',
  components: { TaskView },
};
</script>

<template lang="pug">
TaskView
</template>

<style scoped lang="scss">

</style>
